import React from 'react';
import { useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import { userInfoState } from '../HomeSlice';

export default function EndAppBarTicketList(props) {
  const classes = useStyles();
  const user = useSelector(userInfoState);
  const {
    handleClickClearAllFilters,
    handleClickOpenSetting,
    handleClickOpen,
    handleExcelExport,
  } = props;
  const { t } = useTranslation();

  return (
    <Grid
      container
      justify="flex-end"
      alignItems="flex-end"
      className={classes.endBar}
    >
      {(user.internal || user.hasEmilyDRights || user.externalMax) && (
        <Button
          aria-label="settings"
          className={classes.settingButton}
          onClick={handleExcelExport}
        >
          {t('export excel')}{' '}
        </Button>
      )}
      <Button
        aria-label="settings"
        className={classes.settingButton}
        onClick={handleClickClearAllFilters}
      >
        {' '}
        {t('clear all filters')}
      </Button>
      <Button
        aria-label="settings"
        className={classes.settingButton}
        onClick={handleClickOpenSetting}
      >
        {' '}
        {t('table settings')}
      </Button>
      <Button
        aria-label="add"
        onClick={handleClickOpen}
        className={classes.addButton}
      >
        {t('add a new ticket')}

        <AddCircleIcon className={classes.addIcon} />
      </Button>
    </Grid>
  );
}
